export default "__VITE_ASSET__Dqlw_Ksw__"